import { Injectable } from '@angular/core';
import { CustomView } from 'src/app/shared/components/odata-filter/models/custom-view';
import { FilterOperatorType } from 'src/app/shared/components/odata-filter/models/filter-operator-type';
import { OPERATORS } from 'src/app/shared/components/odata-filter/models/operators';
import { SavedFilter } from 'src/app/shared/components/odata-filter/models/saved-filter';
import { SelectedFilter } from 'src/app/shared/components/odata-filter/models/selected-filter';
import { TEAM_SYSTEM_FILTER_MODELS } from 'src/app/shared/components/odata-filter/models/system-filter-models';
import { ViewContext } from 'src/app/shared/components/odata-filter/models/view-context';
import { TeamFilterResult } from 'src/app/shared/models/team/teamFilterResult';
import { BaseODataService } from 'src/app/shared/services/base-odata.service';
import { yesterday } from 'src/app/shared/utils/date-utils';
import { TeamOrderByFields } from 'src/app/teams/teams-home/team-regular-fields';

// Provided per widget component (not root) so each instance keeps its own filter state.
@Injectable()
export class UpcomingTeamsService extends BaseODataService {
  constructor() {
    super();

    this._baseUrl = 'teams';
    this._filterResult = new TeamFilterResult();
    this.orderBy = [TeamOrderByFields.startDate];
  }

  addUpcomingTeamsFilterToView(view: CustomView) {
    view.name = `Upcoming Teams - ${view.name}`;
    view.id = `UpcomingTeams-${view.id}`;
    view.filters.push(SavedFilter.parseToString(this.getUpcomingTeamsFilter()));
    this.customViewService.addToViews(view);
  }

  applyUpcomingTeamsFilter(view: CustomView) {
    let filters = SavedFilter.parseToAppliedFilters(view.filters, ViewContext.Teams);
    filters.push(this.getUpcomingTeamsFilter());
    this.applyFilter(filters);
  }

  getUpcomingTeamsFilter() {
    return new SelectedFilter({
      filter: TEAM_SYSTEM_FILTER_MODELS.TeamStartDateFilterModel,
      filterOperator: OPERATORS.Date.operators.find(
        (op) => op.displayOperator == FilterOperatorType.gt
      ),
      searchValue: yesterday()
    });
  }
}
